<script lang="ts">
	import type { CompleteVariant, SDSVariant } from '$lib/types';
	import { classes } from '@thearc-hq/ui-kit/utils';
	import { getTranslate } from '@tolgee/svelte';
	import { cart } from '$lib/store/cart.store';
	enum StockInfo {
		LowStock,
		InStock,
		OutOfStock
	}
	const stockData: Record<StockInfo, { color: string; key: string }> = {
		[StockInfo.InStock]: {
			color: 'bg-special-success',
			key: 'product.inStock'
		},
		[StockInfo.LowStock]: {
			color: 'bg-special-warn',
			key: 'product.lowStockNew'
		},
		[StockInfo.OutOfStock]: {
			color: 'bg-special-danger',
			key: 'product.notAvailable'
		}
	};
	export let sdsVariant: SDSVariant;
	export let variant: CompleteVariant;

	$: maxQuantity = $cart.getRealQuantity(
		variant.sku?.value || '',
		Math.max(sdsVariant.quantityAvailable ?? 0, variant.quantityAvailable ?? 0)
	);

	$: stockInfo =
		stockData[
			(() => {
				if (maxQuantity === 0) {
					return StockInfo.OutOfStock;
				}
				if (maxQuantity < 10) {
					return StockInfo.LowStock;
				}
				return StockInfo.InStock;
			})()
		];

	const { t } = getTranslate();
</script>

<div class="flex items-center gap-3 text-p-14 !font-semibold mt-6 mb-8">
	<div class="i-sprenger-truck w-6 h-6"></div>
	{$t(stockInfo.key, { amount: maxQuantity })}
	<span class={classes('inline-block w-2 h-2 rounded-full', stockInfo.color)}></span>
</div>
